// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-pages-header[data-v-121538da]{box-sizing:border-box;margin-bottom:10px}@media(max-width:960px){.search-pages-header[data-v-121538da]{margin-bottom:0}}", ""]);
// Exports
module.exports = exports;
